import React, { useState } from 'react';
import { connect, useDispatch } from 'umi';
import NavBody from './NavBody';
import FoldButton from '@/pages/dashboard/components/FoldButton';
import { useSyncCopilotLeftMenuCollapse } from '@/pages/aigc/pages/Agent/hooks/useCopilotLeftMenuCollapsed';

function LeftMenu({ listMenu, isExpand }: any) {
  const dispatch = useDispatch();
  useSyncCopilotLeftMenuCollapse((expanded) => {
    dispatch({
      type: 'opinionMarketingMenu/toggleMenuExpand',
      payload: { menuExpand: expanded },
    });
  });
  const [showBottomBtn, setShowBottomBtn] = useState(false);
  function toggleExpand() {
    dispatch({ type: 'opinionMarketingMenu/toggleMenuExpand' });
  }

  return (
    <div
      className={`navmenu dbo-navmenu ${
        isExpand ? 'normal-with' : 'small-with'
      }`}
      onMouseEnter={() => {
        !showBottomBtn && setShowBottomBtn(true);
      }}
      onMouseLeave={() => {
        showBottomBtn && setShowBottomBtn(false);
      }}
    >
      <NavBody
        isExpand={isExpand}
        listMenu={listMenu}
        toggleExpand={toggleExpand}
      />
      <div className="navmenu-ft">
        <div className="navmenu-ft-left"></div>
        <div
          className="navmenu-ft-right"
          style={{
            display: showBottomBtn ? 'flex' : 'none',
          }}
          onClick={() => toggleExpand()}
        >
          <FoldButton isExpand={isExpand} />
        </div>
      </div>
    </div>
  );
}

export default connect((state: any) => {
  const { opinionMarketingMenu } = state;
  return {
    isExpand: opinionMarketingMenu.menuExpand,
    listMenu: opinionMarketingMenu.listMenu,
    listMenuLoading: opinionMarketingMenu.listMenuLoading,
  };
})(LeftMenu);
